// src/components/Navbar.jsx
import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import '../css/Navbar.css';

const Navbar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [projectCategories, setProjectCategories] = useState([]);
  const [settings, setSettings] = useState(null); // for logo and mobile

  useEffect(() => {
    // Fetch project categories
    fetch("https://adinathbuilder.com/admin/api/project/category")
      .then(res => res.json())
      .then(data => {
        if (data?.status && Array.isArray(data.data)) {
          setProjectCategories(data.data);
        } else {
          console.error("Invalid category data:", data);
        }
      })
      .catch(err => console.error("Error fetching categories:", err));

    // Fetch app settings (logo, mobile)
    fetch("https://adinathbuilder.com/admin/api/app/settings")
      .then(res => res.json())
      .then(data => {
        if (data?.status && data.data) {
          setSettings(data.data);
        } else {
          console.error("Invalid settings data:", data);
        }
      })
      .catch(err => console.error("Error fetching settings:", err));
  }, []);

  const toSlug = (text) =>
    "/" + text.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');

  const logoUrl = settings?.logo
    ? `https://adinathbuilder.com/admin/public/${settings.logo}`
    : '';

  const mobileNumber = settings?.mobile || '8191000879';

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-light bg-light py-0">
        <div className="container">
          <Link className="navbar-brand" to="/" onClick={() => setIsNavCollapsed(true)}>
            {logoUrl && <img src={logoUrl} alt="logo" />}
          </Link>

          <button className="navbar-toggler" type="button" onClick={() => setIsNavCollapsed(!isNavCollapsed)}>
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`}>
            <ul className="navbar-nav ms-lg-5 ms-3">
              <li className="nav-item"><Link className="nav-link men-link" to="/">HOME</Link></li>
              <li className="nav-item"><Link className="nav-link men-link" to="/about-us">ABOUT US</Link></li>

              <li className="nav-item dropdown">
                <span className="nav-link men-link dropdown-toggle" data-bs-toggle="dropdown">PROJECTS</span>
                <ul className="dropdown-menu">
                  {projectCategories.map(cat => (
                    <li key={cat.id}>
                      <Link
                        className="dropdown-item"
                        to={toSlug(cat.name)}
                        onClick={() => setIsNavCollapsed(true)}
                      >
                        {cat.name.toUpperCase()}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              <li className="nav-item dropdown">
                <span className="nav-link men-link dropdown-toggle" data-bs-toggle="dropdown">GALLERY</span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/image-gallery">IMAGES</Link></li>
                  <li><Link className="dropdown-item" to="/">VIDEOS</Link></li>
                </ul>
              </li>

              <li className="nav-item"><Link className="nav-link men-link" to="/career">CAREER</Link></li>
              <li className="nav-item"><Link className="nav-link men-link" to="/visit">VISITS</Link></li>
              <li className="nav-item"><Link className="nav-link men-link" to="/contact-us">CONTACT US</Link></li>

              <button className="call-button">
                <a className="text-white" href={`tel:+91-${mobileNumber}`}>
                  <i className="fa fa-phone"></i> <span>+91 {mobileNumber}</span>
                </a>
              </button>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
